<template>
  <div>
    <PageTitleVue
      :sub-title="'Gerencie seus colaboradores e membros da equipe'"
    >

      Colaboradores

      <template #b-action>
        <Create
          @click="router.push('/collab/new')"
          :icon="UserPlusIcon"
          :label="'Adicionar'"
          :menu-active="'Colaboradores'"
        />
      </template>

    </PageTitleVue>

    <section>
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">

        <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
          <DropDownOptions
            v-model="selectedFilter"
            :label="'Tipo de acesso'"
            :options="[
              'Todos',
              ...filters
            ]"
          />

          <SearchInput v-model="searchTerm" />
        </div>

        <DataTable :data="filteredData">
          <template #head>
            <th scope="col" class="px-6 py-3">Nome</th>
            <th scope="col" class="px-6 py-3">Celular</th>
            <th scope="col" class="px-6 py-3">Função</th>
            <th scope="col" class="px-6 py-3 text-center">Tipo de permissão</th>
            <th scope="col" class="px-6 py-3 text-center">#</th>
          </template>
        </DataTable>
      </div>
    </section>

  </div>
</template>

<script setup>
import DropDownOptions from '@/components/Tables/DropDownOptions.vue'
import SearchInput from '@/components/Tables/SearchInput.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CollabService from './services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import DataTable from './components/DataTable.vue'
import router from '@/router'
import { storeApp } from '@/store'
import { onBeforeMount, ref, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'

import { UserPlusIcon } from '@heroicons/vue/24/outline'

const appStore = storeApp.state
const dataTable = ref([])
const selectedFilter = ref('')
const searchTerm = ref('')

const filters = computed(() => {
  if (dataTable.value) { return [...new Set(dataTable.value.map(i => i.permission_type))] }
})

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable?.value?.filter((row) => {
    if (selectedFilter.value === 'Todos') { selectedFilter.value = '' }

    const matchesDropdown = !selectedFilter.value || row.permission_type === selectedFilter.value

    const matchesSearch = !searchTerm.value ||
      ['name', 'function', 'permission_type', 'email', 'phone'].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesDropdown && matchesSearch
  })
})

onBeforeMount(async () => {
  appStore.loading = true
  await getCollaborators()
  appStore.loading = false
})

async function getCollaborators () {
  await CollabService.getAllColaborators()
    .then(res => {
      console.log(res.data)
      // dataTable.value = res.data.filter(el => el.id !== localStorage.getItem('__uuid')) // para não mosrar o usuário atual
      dataTable.value = res.data
    }).catch(err => {
      toast(
        'Erro',
        'Algo deu errado ao buscar colaboradores',
        'error'
      )
    })
}

</script>
